export const PAYMENT_METHOD = {
  PACKAGE: 'Package',
  BANK_TRANSFERS: 'BankTransfers',
  CARD: 'Card',
}

export const PAYMENT_METHOD_NOT_INCLUDE_PACKAGE = {
  BANK_TRANSFERS: 'BankTransfers',
  CARD: 'Card',
}
